interface Params {
    [key: string]: string | number | undefined;
}

export function formatQuery(params: Params, appendQuestionMark = true): string {
    if (Object.keys(params).length === 0) {
        return '';
    }

    const urlParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (!value) {
            continue;
        }
        urlParams.append(key, value.toString());
    }

    return (appendQuestionMark ? '?' : '') + urlParams.toString();
}

export function parseQuery(search: string): URLSearchParams {
    return new URLSearchParams(search);
}
